/**
 * Analytics Handler
 */
function onShareClick(data) {
  console.log("📤 [TRACKING] Share clicked:", data);
}

function onDownloadClick(data) {
  console.log("⬇️ [TRACKING] Download clicked:", data);
}

// Shopify Share Cart Script
class ShopifyShareCart {
  constructor() {
    this.observer = null;
    this.pdfLogoUrl = window.SHARE_PDF_LOGO_URL || null;
    this.pdfCssUrl  = window.SHARE_PDF_CSS_URL  || null;
    this.init();
  }

  track(event, payload = {}) {
    try {
      const url = window.SHARE_TRACK_URL;
      if (!url) return;

      const body = JSON.stringify({
        event,
        ts: Date.now(),
        href: location.href,
        shop: location.hostname,
        ...payload,
      });

      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: "application/json" });
        navigator.sendBeacon(url, blob);
      } else {
        fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          keepalive: true,
          body
        }).catch(() => {});
      }
    } catch {}
  }


  init() {
    this.addShareButton();
    this.checkForSharedCart();
    this.observeCartChanges();
  }

  // Observe cart drawer changes to re-insert button when needed
  observeCartChanges() {
    const targetNode = document.body;
    const config = { childList: true, subtree: true };

    const callback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          // Check if cart drawer was added or modified
          const cartDrawer = document.querySelector(
            "[data-cart-drawer], .cart-drawer, #CartDrawer, .drawer__content"
          );
          if (cartDrawer && !cartDrawer.querySelector(".share-cart-btn")) {
            this.insertShareButton();
          }
        }
      }
    };

    this.observer = new MutationObserver(callback);
    this.observer.observe(targetNode, config);
  }

  addShareButton() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () =>
        this.insertShareButton()
      );
    } else {
      this.insertShareButton();
    }
  }

  insertShareButton() {
    const cartDrawer = document.querySelector(
      "[data-cart-drawer], .cart-drawer, #CartDrawer, .drawer__content"
    );
    const checkoutButton = document.querySelector(
      "[name='checkout'], .btn--checkout, .cart__checkout-button, [data-cart-checkout]"
    );
    const drawerHeading = document.querySelector(".drawer__heading");

    if (
      cartDrawer &&
      checkoutButton &&
      drawerHeading &&
      !cartDrawer.querySelector(".share-cart-btn")
    ) {
      const container = document.createElement("div");
      container.className = "share-cart-container";
      // Дочерний элемент .drawer__heading — сидит сразу после текста "Cart"
      // на той же строке, а не отдельным флекс-айтемом в .drawer__header
      // (который был бы раскидан justify-content: space-between).
      container.style.cssText = `position: relative; display: inline-flex; vertical-align: middle; margin-left: 10px;`;

      // Единая кнопка Share — по клику открывает мини-дропдаун (Share / Download)
      // над кнопкой, вместо двух отдельных кнопок. inline-flex + не на всю
      // ширину — кнопка размером по контенту, прижата к левому краю.
      const mainButton = document.createElement("button");
      mainButton.type = "button";
      mainButton.className = "share-cart-btn share-main-btn";
      mainButton.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="18" cy="5" r="3"></circle>
        <circle cx="6" cy="12" r="3"></circle>
        <circle cx="18" cy="19" r="3"></circle>
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
      </svg> Share`;
      mainButton.style.cssText = `padding: 6px 10px; background: none; border: none; border-radius: 3px; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; gap: 5px; font-size: 12px; color: var(--color-ink, #121212); white-space: nowrap; transition: opacity 0.2s ease;`;
      mainButton.addEventListener("mouseenter", () => { mainButton.style.opacity = "0.7"; });
      mainButton.addEventListener("mouseleave", () => { mainButton.style.opacity = "1"; });

      const dropdown = document.createElement("div");
      dropdown.className = "share-cart-dropdown";
      dropdown.hidden = true;
      // Кнопка теперь у самого верха drawer — дропдаун открывается ВНИЗ
      // (было вверх, когда кнопка сидела над checkout в подвале корзины).
      dropdown.style.cssText = `position: absolute; top: calc(100% + 6px); left: 0; min-width: 140px; background: #fff; border-radius: 4px; box-shadow: 0 4px 14px rgba(0,0,0,0.18); overflow: hidden; z-index: 20;`;

      const optionStyle = `width: 100%; padding: 8px 12px; background: #fff; border: none; cursor: pointer; display: flex; align-items: center; gap: 8px; font-size: 12px; color: #333; text-align: left; white-space: nowrap;`;

      // Share option - с трекингом
      const shareOption = document.createElement("button");
      shareOption.type = "button";
      shareOption.className = "share-cart-dropdown-item";
      shareOption.setAttribute("track", "click(time)->onShareClick@action,cartValue");
      shareOption.setAttribute("action", "share_link");
      shareOption.setAttribute("cartValue", this.getCartValue());
      shareOption.style.cssText = optionStyle;
      shareOption.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="18" cy="5" r="3"></circle>
        <circle cx="6" cy="12" r="3"></circle>
        <circle cx="18" cy="19" r="3"></circle>
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
      </svg> Share`;

      // Download option - с трекингом
      const downloadOption = document.createElement("button");
      downloadOption.type = "button";
      downloadOption.className = "share-cart-dropdown-item";
      downloadOption.setAttribute("track", "click(time)->onDownloadClick@action,format,cartValue");
      downloadOption.setAttribute("action", "download");
      downloadOption.setAttribute("format", "pdf");
      downloadOption.setAttribute("cartValue", this.getCartValue());
      downloadOption.style.cssText = optionStyle;
      downloadOption.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <!-- иконка файла -->
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <!-- стрелка вниз (скачать) внутри файла -->
        <line x1="12" y1="11" x2="12" y2="17"></line>
        <polyline points="9 14 12 17 15 14"></polyline>
      </svg> Download`;

      [shareOption, downloadOption].forEach((opt) => {
        opt.addEventListener("mouseenter", () => { opt.style.background = "#f2f2f2"; });
        opt.addEventListener("mouseleave", () => { opt.style.background = "#fff"; });
      });

      const onOutsideClick = (e) => {
        if (!container.contains(e.target)) closeDropdown();
      };
      const closeDropdown = () => {
        dropdown.hidden = true;
        document.removeEventListener("click", onOutsideClick);
      };

      mainButton.addEventListener("click", (e) => {
        e.stopPropagation();
        const willOpen = dropdown.hidden;
        dropdown.hidden = !willOpen;
        if (willOpen) {
          document.addEventListener("click", onOutsideClick);
        } else {
          document.removeEventListener("click", onOutsideClick);
        }
      });

      shareOption.addEventListener("click", () => {
        closeDropdown();
        this.shareCart();
      });
      downloadOption.addEventListener("click", () => {
        closeDropdown();
        this.sharePDF();
      });

      dropdown.appendChild(shareOption);
      dropdown.appendChild(downloadOption);
      container.appendChild(dropdown);
      container.appendChild(mainButton);

      drawerHeading.appendChild(container);
    }
  }

  async getCurrentCart() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error("Error fetching cart:", error);
      return null;
    }
  }

  getCartValue() {
    const cartEl = document.querySelector('[data-cart-total], [data-cart-price]');
    if (cartEl) {
      return cartEl.textContent.trim();
    }
    return "unknown";
  }

  async shareCart() {
    console.log("[SHARE] shareCart(): clicked");
    this.showNotification("Generating link...", "info");

    const cart = await this.getCurrentCart();
    if (!cart || !cart.items || cart.items.length === 0) {
      this.showNotification("Your cart is empty!", "error");
      return;
    }

    // Create cart data for URL with all properties
    const cartItems = cart.items.map((item) => {
      const itemData = {
        id: item.variant_id,
        quantity: item.quantity,
      };

      // Include properties if they exist and are not empty
      if (item.properties && Object.keys(item.properties).length > 0) {
        // Filter out properties with null or undefined values
        const cleanProperties = {};
        for (const [key, value] of Object.entries(item.properties)) {
          if (value !== null && value !== undefined && value !== "") {
            cleanProperties[key] = value;
          }
        }
        if (Object.keys(cleanProperties).length > 0) {
          itemData.properties = cleanProperties;
        }
      }

      return itemData;
    });

    // Create base64 encoded string with cart data
    const sid = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`);
    const cartData = btoa(JSON.stringify(cartItems));
    const shareUrl = `${window.location.origin}?shared_cart=${cartData}&sid=${encodeURIComponent(sid)}`;
    console.log("[SHARE] shareCart(): shareUrl", shareUrl);

    // Отправляем событие отслеживания
    this.track("share_link_created", {
      sid,
      item_count: cart.item_count,
      total_price: cart.total_price
    });

    this.openShareOptions(shareUrl);
  }

  buildShareLinks(url, text) {
    const u = encodeURIComponent(url);
    const t = encodeURIComponent(text || document.title || "Cart");
    return {
      whatsapp: `https://wa.me/?text=${t}%20${u}`,
      telegram: `https://t.me/share/url?url=${u}&text=${t}`,
      email: `mailto:?subject=${t}&body=${t}%0A${u}`,
      sms: this.isIOS() ? `sms:&body=${t}%20${u}` : `sms:?body=${t}%20${u}`,
      x: `https://twitter.com/intent/tweet?text=${t}&url=${u}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
      viber: `viber://forward?text=${t}%20${u}`,
    };
  }

  isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  loadIcons(container) {
    const templates = document.getElementById("share-icon-templates");
    if (!templates) return;

    container.querySelectorAll(".share-icon[data-icon]").forEach((span) => {
      const iconName = span.getAttribute("data-icon");
      const template = templates.querySelector(
        `template[data-icon="${iconName}"]`
      );
      if (template) {
        span.innerHTML = template.innerHTML;
      }
    });
  }

  openShareOptions(shareUrl) {
    console.log("[SHARE] openShareOptions():", shareUrl);
    const links = this.buildShareLinks(shareUrl, "Shared cart");

    const overlay = document.createElement("div");
    overlay.className = "share-cart-overlay";

    const modal = document.createElement("div");
    modal.className = "share-cart-modal";

    modal.innerHTML = `
      <div class="share-cart-modal-header">
        <strong>Share cart</strong>
      </div>
      <div class="share-cart-grid">
        <a data-channel="whatsapp" class="share-opt" href="${links.whatsapp}" target="_blank" rel="noopener">
          <span class="share-icon" data-icon="whatsapp"></span>
          <span>WhatsApp</span>
        </a>
        <a data-channel="telegram" class="share-opt" href="${links.telegram}" target="_blank" rel="noopener">
          <span class="share-icon" data-icon="telegram"></span>
          <span>Telegram</span>
        </a>
        <a data-channel="email" class="share-opt" href="${links.email}">
          <span class="share-icon" data-icon="email"></span>
          <span>Email</span>
        </a>
        <a data-channel="sms" class="share-opt" href="${links.sms}">
          <span class="share-icon" data-icon="sms"></span>
          <span>SMS/iMessage</span>
        </a>
        <a data-channel="linkedin" class="share-opt" href="${links.linkedin}" target="_blank" rel="noopener">
          <span class="share-icon" data-icon="linkedin"></span>
          <span>LinkedIn</span>
        </a>
        <button type="button" class="share-opt share-copy" data-channel="copy">
          <span class="share-icon" data-icon="copy"></span>
          <span>Copy link</span>
        </button>
      </div>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // Load icons
    this.loadIcons(modal);

    // ТРЕКИНГ: Добавляем track атрибут ПОСЛЕ создания элементов через setAttribute
    modal.querySelectorAll(".share-opt[data-channel]").forEach(el => {
      const channel = el.getAttribute("data-channel");
      
      // Добавляем track атрибут и значения для SDK
      el.setAttribute("track", "click(time)->onShareClick@channel,action");
      el.setAttribute("channel", channel);
      el.setAttribute("action", "share_modal");
      
      el.addEventListener("click", () => {
        try {
          const u = new URL(shareUrl);
          const sid = u.searchParams.get("sid") || null;
          
          this.track("share_channel_click", {
            sid,
            channel: channel
          });
        } catch {}
      });
    });

    // Закрытие
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) overlay.remove();
    });

    // Копирование
    modal.querySelector(".share-copy").addEventListener("click", () => {
      this.copyToClipboard(shareUrl);
    });
  }

  showManualCopyPrompt(text) {
    console.log("[SHARE] showManualCopyPrompt");
    const wrap = document.createElement("div");
    wrap.className = "share-copy-prompt-overlay";

    const box = document.createElement("div");
    box.className = "share-copy-prompt-box";

    box.innerHTML = `
      <div class="share-copy-prompt-header">
        <strong>Copy link</strong>
      </div>
      <div class="share-copy-input-wrapper">
        <input class="share-copy-input" type="text" value="${text}" readonly>
        <button class="share-copy-btn">
          <span class="share-icon" data-icon="copy"></span>
          <span>Copy</span>
        </button>
      </div>
      <div class="share-copy-tip">Tip: ${/Mac/i.test(navigator.platform) ? "⌘C" : "Ctrl+C"} to copy</div>
    `;

    wrap.appendChild(box);
    document.body.appendChild(wrap);

    // Load icon
    this.loadIcons(box);

    const input = box.querySelector(".share-copy-input");
    const close = () => wrap.remove();

    // Закрытие по клику мимо
    wrap.addEventListener("click", (e) => {
      if (e.target === wrap) close();
    });

    // Авто-выделение
    setTimeout(() => {
      input.focus();
      input.select();
    }, 0);

    box.querySelector(".share-copy-btn").addEventListener("click", async () => {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
          this.showNotification("Copied!", "success");
          close();
          return;
        }
      } catch {}

      try {
        input.focus();
        input.select();
        if (document.execCommand("copy")) {
          this.showNotification("Copied!", "success");
          close();
          return;
        }
      } catch {}

      this.showNotification("Select the text and press ⌘C/Ctrl+C", "error");
    });
  }

  async copyToClipboard(text) {
    console.log("[SHARE] copyToClipboard(): start");

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        console.log("[SHARE] copyToClipboard(): clipboard.writeText success");
        this.showNotification("Cart link copied to clipboard!", "success");
        try {
          const sid = new URL(text).searchParams.get("sid") || null;
          this.track("share_copy_success", { sid });
        } catch {}

        return;
      } catch (error) {
        console.warn(
          "[SHARE] copyToClipboard(): clipboard.writeText failed",
          error
        );
      }
    } else {
      console.warn(
        "[SHARE] copyToClipboard(): clipboard API unavailable or insecure context"
      );
    }

    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, ta.value.length);
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);

      if (ok) {
        console.log("[SHARE] copyToClipboard(): execCommand copy success");
        this.showNotification("Cart link copied to clipboard!", "success");
        try {
          const sid = new URL(text).searchParams.get("sid") || null;
          this.track("share_copy_success", { sid });
        } catch {}

        return;
      }

      console.warn("[SHARE] copyToClipboard(): execCommand returned false");
    } catch (err) {
      console.warn("[SHARE] copyToClipboard(): execCommand failed", err);
    }

    this.showManualCopyPrompt(text);
  }

  printViaIframe(html) {
    console.log("[SHARE] printViaIframe(): start");

    const iframe = document.createElement("iframe");
    iframe.setAttribute("aria-hidden", "true");
    iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:none;";
    document.body.appendChild(iframe);

    const frameWindow = iframe.contentWindow;
    const frameDoc = frameWindow.document;
    frameDoc.open();
    frameDoc.write(html);
    frameDoc.close();

    let printed = false;
    const printOnce = () => {
      if (printed) return;
      printed = true;
      try {
        frameWindow.focus();
        frameWindow.print();
      } catch (error) {
        console.error("[SHARE] printViaIframe() error:", error);
      }
      setTimeout(() => iframe.remove(), 1000);
    };

    // Логотип и share-pdf.css грузятся из CDN — печатаем после них,
    // иначе в диалог уходит документ без шапки и стилей
    if (frameDoc.readyState === "complete") {
      setTimeout(printOnce, 50);
    } else {
      frameWindow.addEventListener("load", printOnce);
    }
    setTimeout(printOnce, 3000);
  }

  async sharePDF() {
    console.log("[SHARE] sharePDF(): clicked");
    this.showNotification("Generating PDF...", "info");

    const cart = await this.getCurrentCart();
    if (!cart || !cart.items || cart.items.length === 0) {
      this.showNotification("Your cart is empty!", "error");
      return;
    }

    const html = this.generatePDFHTML(cart);

    if (typeof html2pdf !== "undefined") {
      html2pdf().setOptions({ margin: 10, filename: "cart.pdf" }).html(html).save();
    } else {
      this.printViaIframe(html);
    }

    this.track("share_pdf_created", {
      item_count: cart.item_count,
      total_price: cart.total_price
    });
  }

  // Логотип берём тот же, что стоит в шапке сайта; SHARE_PDF_LOGO_URL —
  // запасной вариант, если шапки на странице нет
  getLogoUrl() {
    const headerLogo = document.querySelector(".header__heading-logo");
    return (headerLogo && (headerLogo.src || headerLogo.currentSrc)) || this.pdfLogoUrl;
  }

  generatePDFHTML(cart) {
    const currentDate = new Date();

    const itemsHTML = cart.items.map((item, index) => {
      const price = (item.price / 100).toFixed(2);
      const lineTotal = ((item.price * item.quantity) / 100).toFixed(2);
      return `
        <tr>
          <td style="text-align:center;">${index + 1}</td>
          <td>
            <strong>${item.title}</strong>
            ${item.variant_title ? `<br><small>${item.variant_title}</small>` : ""}
          </td>
          <td style="text-align:center;">${item.quantity}</td>
          <td style="text-align:right;">$${price}</td>
          <td style="text-align:right;">$${lineTotal}</td>
        </tr>
      `;
    }).join("");

    const formatPrice = (cents) => (cents / 100).toFixed(2);
    const logoUrl = this.getLogoUrl();
    const cssLink = this.pdfCssUrl ? `<link rel="stylesheet" href="${this.pdfCssUrl}">` : "";

    return `<!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Cart Summary</title>
      ${cssLink}
      <style>
        body { font-family: Arial, sans-serif; color: #333; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { padding: 10px; text-align: left; border-bottom: 1px solid #ddd; }
        th { background-color: #f5f5f5; font-weight: bold; }
        .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 30px; }
        .company-logo { max-height: 70px; width: auto; display: block; }
        .quote-info { text-align: right; }
        .totals-section { margin-top: 30px; }
        .totals-row { display: flex; justify-content: space-between; padding: 8px 0; }
        .total { font-weight: bold; font-size: 16px; border-top: 2px solid #333; padding-top: 10px; margin-top: 10px; }
        .tax-shipping-note { margin-top: 18px; font-size: 12px; color: #555; font-style: italic; }
        .footer { margin-top: 60px; padding-top: 12px; text-align: center; font-size: 12px; color: #111; }
        .footer p { margin: 2px 0; }
        .footer a { color: #111; }
      </style>
    </head>
    <body class="share-pdf">
      <main class="pdf-main">
        <div class="header">
          <div class="company-info">
            ${logoUrl ? `<img class="company-logo" src="${logoUrl}" alt="Kompozit">` : `<h1>Kompozit</h1>`}
          </div>
          <div class="quote-info">
            <h2 class="doc-title">Cart Summary</h2>
            <p>${currentDate.toLocaleDateString()}</p>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th style="width:40px;">#</th>
              <th>Product Details</th>
              <th style="width:80px;">QTY</th>
              <th style="width:100px;">Unit Price</th>
              <th style="width:110px;">Line Total</th>
            </tr>
          </thead>
          <tbody>
            ${itemsHTML}
          </tbody>
        </table>

        <div class="totals-section">
          <div class="totals-row">
            <span>Subtotal:</span>
            <strong>$${formatPrice(cart.total_price)}</strong>
          </div>
          ${cart.total_discount > 0 ? `<div class="totals-row"><span>Discount:</span><strong>-$${formatPrice(cart.total_discount)}</strong></div>` : ""}
          <div class="totals-row total">
            <span>TOTAL:</span>
            <span>$${formatPrice(cart.total_price)}</span>
          </div>
        </div>

        <p class="tax-shipping-note">Taxes and shipping are calculated at checkout.</p>
      </main>

      <div class="footer">
        <div class="contact-block">
          <p><a href="https://kompozitusa.com">kompozitusa.com</a></p>
          <p><a href="mailto:sales@kompozitusa.com">sales@kompozitusa.com</a></p>
        </div>
      </div>
    </body>
    </html>`;
  }

  // Check URL for shared cart data
  checkForSharedCart() {
    const urlParams = new URLSearchParams(window.location.search);
    const sharedCartData = urlParams.get("shared_cart");

    if (sharedCartData) {
      this.loadSharedCart(sharedCartData);
    }
  }

  // Load shared cart into user's cart
  async loadSharedCart(cartData) {
    try {
      const items = JSON.parse(atob(cartData));

      // Show notification
      this.showNotification("Loading shared cart...", "info");

      // Add items one by one with properties
      let successCount = 0;
      let failCount = 0;

      for (const item of items) {
        try {
          await this.addToCart(
            item.id,
            item.quantity,
            item.properties || {}
          );
          successCount++;
        } catch (error) {
          console.error(`Failed to add item ${item.id}:`, error);
          failCount++;
        }
      }

      if (successCount > 0) {
        this.showNotification(
          `Successfully added ${successCount} item(s) to cart!${failCount > 0 ? ` (${failCount} failed)` : ""}`,
          "success"
        );
      } else {
        this.showNotification("Failed to add items to cart.", "error");
      }

      // Remove parameter from URL
      const url = new URL(window.location);
      url.searchParams.delete("shared_cart");
      window.history.replaceState({}, document.title, url.pathname + url.search);

      // Refresh cart drawer if open
      setTimeout(() => {
        this.refreshCartDrawer();
      }, 500);
    } catch (error) {
      console.error("Error loading shared cart:", error);
      this.showNotification("Failed to load shared cart. Invalid data.", "error");
    }
  }

  // Add item to cart
  async addToCart(variantId, quantity, properties = {}) {
    const formData = {
      id: variantId,
      quantity: quantity,
    };

    // Only add properties if they exist and are not empty
    if (properties && Object.keys(properties).length > 0) {
      formData.properties = properties;
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || "Failed to add item to cart");
      }

      return await response.json();
    } catch (error) {
      console.error("Error adding item to cart:", error);
      throw error;
    }
  }

  // Refresh cart drawer
  refreshCartDrawer() {
    // Trigger cart update (may vary by theme)
    if (window.theme && window.theme.cartDrawer) {
      window.theme.cartDrawer.getCart();
    } else if (window.cartDrawer) {
      window.cartDrawer.getCart();
    } else if (document.querySelector("[data-cart-refresh]")) {
      document.querySelector("[data-cart-refresh]").click();
    } else {
      // Reload page as fallback
      window.location.reload();
    }
  }

  // Show notifications
  showNotification(message, type = "info") {
    // Create notification element
    const notification = document.createElement("div");
    notification.className = `share-cart-notification ${type}`;
    notification.textContent = message;

    // Notification styles
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 12px 20px;
      border-radius: 4px;
      color: white;
      font-size: 14px;
      font-weight: 500;
      z-index: 10000;
      opacity: 0;
      transform: translateY(-10px);
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;

    // Colors based on type
    const colors = {
      success: "#4CAF50",
      error: "#f44336",
      info: "#2196F3",
    };
    notification.style.backgroundColor = colors[type] || colors.info;

    document.body.appendChild(notification);

    // Show animation
    setTimeout(() => {
      notification.style.opacity = "1";
      notification.style.transform = "translateY(0)";
    }, 100);

    // Remove after 3 seconds
    setTimeout(() => {
      notification.style.opacity = "0";
      notification.style.transform = "translateY(-10px)";
      setTimeout(() => {
        if (notification.parentNode) {
          document.body.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }
}

// Initialize Share Cart when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new ShopifyShareCart();
  });
} else {
  new ShopifyShareCart();
}